import type { RenderComponentProps } from "../../../shared/types";

import * as React from "react";

import useScript from "../../../shared/hooks/useScript";
import {
  GlobalWindowContext,
  RuntimeHooksContext,
  useRuntimeContext,
} from "../../../shared/runtime-context";
import { useProductFromProps } from "../../hooks/useProductFromProps";
import { SharedShopifyLiquid } from "../SharedShopifyLiquid";

const BuyWithPrimeButton: React.FC<RenderComponentProps> = ({
  componentAttributes: attributes,
  component,
  context,
}) => {
  const { _siteId, _widgetId } = component.props;
  const isEditorCanvas =
    useRuntimeContext(
      RuntimeHooksContext,
    ).useIsEditorEditModeRenderEnvironment();
  const globalWindow = useRuntimeContext(GlobalWindowContext);
  const product = useProductFromProps(component.props, context);
  const variantSku = product?.variant?.sku;
  const selectedQuantity = product?.quantity;

  const quantity = selectedQuantity ?? 1;
  const updateWidget = React.useCallback(() => {
    if (
      !isEditorCanvas &&
      globalWindow?.bwp?.updateWidget &&
      variantSku &&
      (variantSku !== globalWindow.bwp.sku ||
        quantity !== globalWindow.bwp.quantity)
    ) {
      globalWindow.bwp.updateWidget(variantSku, quantity);
    }
  }, [variantSku, quantity, globalWindow, isEditorCanvas]);

  useScript("https://code.buywithprime.amazon.com/bwp.v1.js", {
    globalWindow,
    forceSkip: isEditorCanvas,
    onLoad: () => {
      // Update widget once on load, since we might be on a PDP and might not
      // have pre-rendered the variant sku
      updateWidget();
    },
  });
  React.useEffect(() => {
    // Update widget any time the variant SKU or quantity changes
    updateWidget();
  }, [updateWidget]);

  const liquidSource = `<div
          id="amzn-buy-now"
          data-site-id="${_siteId}"
          data-widget-id="${_widgetId}"
          data-sku="{{ reploSelectedVariant.sku }}"
        ></div>`;

  const description =
    _siteId && _widgetId
      ? undefined
      : "Set your Buy With Prime Site ID and Widget ID in the Config tab, then preview or publish to view this component.";
  return (
    <SharedShopifyLiquid
      liquidSource={liquidSource}
      componentId={component.id}
      componentAttributes={attributes}
      isLiquidSupported={true}
      description={description}
      title="Buy With Prime Button"
    />
  );
};

export default BuyWithPrimeButton;
